import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { Spin, Table, Typography } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import { GetInvoiceTemplateApi } from "../../../api/request/invoice";

const { Title } = Typography;

const ViewInvoice = ({ isOpen, setIsOpen, selectedTemplate }) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getInvoiceTemplate = async (id) => {
    try {
      setIsLoading(true);
      const { data } = await GetInvoiceTemplateApi({
        invoice_template_id: id,
      });
      if (data.status) setData(data?.data);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTemplate?.id && isOpen)
      getInvoiceTemplate(selectedTemplate?.id);
  }, [selectedTemplate, isOpen]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      render: (text) => text || "--",
    },
    {
      title: "Description",
      dataIndex: "description",
      align: "center",
      render: (text) => text || "--",
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      align: "center",
      render: (text) => text || "1",
    },
    {
      title: "Unit Price",
      dataIndex: "charge",
      align: "center",
      render: (text) => text || "--",
    },
    {
      title: "Tax",
      dataIndex: "tax",
      align: "center",
      render: (text) => text || "0%",
    },
    {
      title: "Amount",
      dataIndex: "charge",
      align: "right",
      render: (value) => (
        <p className="text-green-600 font-bold">${Number(value).toFixed(2)}</p>
      ),
    },
  ];

  const formatAmount = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      width={800}
      className="top-[50px]"
    >
      {isLoading ? (
        <div className="flex justify-center items-center">
          <Spin />
        </div>
      ) : (
        <div className="bg-white h-[700px] overflow-y-auto space-y-5">
          <div className="flex justify-between border-b pb-4">
            <Title level={2} className="text-right">
              Invoice
            </Title>
          </div>

          <div className="text-right space-y-2">
            <div className="text-gray-600">
              {/* {data?.address?.split(",")?.map((item) => ( */}
              <p>{data?.address},</p>
              {/* ))} */}
            </div>

            <Title level={5} className="">
              {data?.business_name}
            </Title>

            <div>
              <a
                href={`mailto:${data?.admin?.email}`}
                className="text-blue-500"
              >
                {data?.admin?.email}
              </a>
            </div>

            <div>
              <span className="font-bold me-1">Invoice Date:</span>
              {moment(data?.created_at).format("LL")}
            </div>

            <p>
              <span className="font-bold me-1">GST:</span>
              {data?.admin?.gst_no}
            </p>

            <p>
              <span className="font-bold me-1">Phone:</span>{" "}
              {data?.phone_no || data?.admin?.mobile_no || "--"}
            </p>
          </div>

          <div>
            <span className="font-bold me-1">To:</span>
            {data?.admin?.name}
          </div>

          <div>
            <Title level={4}>Itemized Bill:</Title>
            <Table
              dataSource={data?.title ? JSON.parse(data.title) : []}
              columns={columns}
              pagination={false}
              bordered
            />
          </div>

          <div className="text-right text-lg font-bold">
            <p>Sub Total: <span>${formatAmount(data?.amount)}</span></p>
            <p>Tax Amount: <span>${formatAmount(data?.tax)}</span></p>
            <p>Total: <span>${formatAmount(data?.amount)}</span></p>
          </div>

          {/* <p>{data?.remark}</p> */}

          <div className="text-center text-gray-500 text-sm">
            <p>Thank you for your business!</p>
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

export default ViewInvoice;
